// src/components/Footer.js
import React from "react";
//import { Link } from "react-router-dom";
import styles from "../css/shared.module.css";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className={styles.footer}>
      <div className={styles.footerContent}>
        <p className={styles.footerCopyright}>
          © {currentYear} AI Community PRO. Todos los derechos reservados.
        </p>
        <nav className={styles.footerLinks}>
          <p to="/terms-of-service" className={styles.footerLink}>
            Términos de Servicio
          </p>
          <span className={styles.footerSeparator}>|</span>
          <p to="/privacy-policy" className={styles.footerLink}>
            Política de Privacidad
          </p>
        </nav>
      </div>
    </footer>
  );
};

export default Footer;
